<template>
  <div class="autoOverflow-flp">
    <div class="container">
      <div class="row headerStyleFlUp" id="flpHeader">
        <div class="col-4">
          <div class="headerNotifStyle">Follow Up Messaging</div>
        </div>

        <div :class="currAdmin.role <= 1 ? 'col-6' : 'col-8'"></div>

        <div class="col-2 rightAlign" v-if="currAdmin.role <= 1">
          <b-button
            class="settingsStyle"
            variant="outline-primary"
            v-b-modal.modal-flp-settings
          >Settings</b-button>
        </div>
        <!-- @click="LoadAvalTime()" -->
      </div>

      <div class="row headerStyleInnerFlUp" id="flpAwaitHeader">
        <div :class="flpToShow == 'sent' ? 'col-3' : 'col-5'">
          <div class="headerStyleFlpInTxtMain">
            <b-form-select
              v-model="flpToShow"
              :options="[{value: 'flp_1', text: 'Scheduled for sending (first touch)'}, {value: 'flp_2', text: 'Scheduled for sending (second touch)'}, {value: 'sent', text: 'Sent / Processed'}]"
              @change="sentList.length == 0 ? loadSentFollowUps() : ''"
              class="mb-3"
            ></b-form-select>

            <!-- {{flpToShow != 'sent' ? 'Scheduled for sending' : 'Sent / Processed'}}{{flpToShow == 'flp_1' ? ' (first touch)' : flpToShow == 'flp_2' ? ' (second touch)': ''}} -->
          </div>
        </div>
        <div class="col-4" v-if="flpToShow != 'sent'"></div>
        <div class="col-2 flp-date-changer" style=" margin-top: 5px;" v-if="flpToShow == 'sent'">
          <b-form-select
            v-model="flpSentTouch"
            :options="flpSentTouchPool"
            @change="FilterSentList()"
            class="mb-3"
          ></b-form-select>
        </div>

        <div class="col-2 flp-date-changer" style=" margin-top: 5px;" v-if="flpToShow == 'sent'">
          <b-form-select
            v-model="sentReplyFilter"
            :options="[{ value: 'all', text: 'All Sent' }, { value: 'reply', text: 'With Customer Reply' }, { value: 'noreply', text: 'No Customer Reply' }]"
            @change="FilterSentList()"
            class="mb-3"
          ></b-form-select>
        </div>
        <div
          class="col-3 flp-date-changer"
          style="text-align: right; margin-top: 5px;"
          v-if="flpToShow == 'sent'"
        >
          <b-form-select
            v-model="datePeriodSelected"
            :options="datePeriodOptions"
            class="mb-3"
            @change="sentDatePeriodIsSelected()"
          ></b-form-select>
        </div>
        <div class="col-1 searchWordStyle" v-if="flpToShow != 'sent'">Search:</div>
        <div class="col-2" v-if="flpToShow != 'sent'" style="padding-left: 0">
          <b-form-input v-model="searchValue" placeholder="By Cust-No"></b-form-input>
        </div>
        <div class="col-2" v-if="flpToShow == 'sent'">
          <b-dropdown
            id="dropdown-form"
            text="search"
            variant="outline-primary"
            ref="searchdropdown"
          >
            <b-dropdown-form v-on:submit.prevent="SearchSentById()">
              <b-form-group label="Search By Id" label-for="search_by_id">
                <b-form-input
                  id="search_by_id"
                  v-model="searchValue_sent"
                  size="sm"
                  placeholder="1000011"
                ></b-form-input>
              </b-form-group>
              <b-button type="submit" variant="outline-primary" size="sm">Search</b-button>
            </b-dropdown-form>
          </b-dropdown>
        </div>
      </div>

      <div
        v-if="(flpToShow != 'sent' && unsentList.length > 0) || (flpToShow == 'sent' && sentList.length > 0)"
        class="row"
      >
        <div class="col-12">
          <div class="row" style="margin-top:20px;">
            <div class="col-1">Cust-No</div>
            <div class="col-2">Name</div>
            <div class="col-2" v-if="flpToShow != 'sent'">Vehicle</div>
            <div class="col-2">Phone</div>
            <div class="col-2" v-if="flpToShow == 'sent'">Customer Replied</div>

            <div class="col-2" v-if="flpToShow != 'sent'">Status</div>
            <div class="col-2" v-if="flpToShow != 'sent'">Scheduled for</div>
            <div class="col-2" v-if="flpToShow == 'sent'">First Message</div>
            <div class="col-2" v-if="flpToShow == 'sent'">Second Message</div>
            <div class="col-1">Follow-up type</div>
          </div>

          <div v-if="flpToShow != 'sent'">
            <customerRow
              v-model="unsentList[unsentList.findIndex(el => el.ssId == unsent.ssId)]"
              v-for="(unsent, ukey) in unsentList.filter(el => el.flp_touch == flpToShow && (searchValue != '' ? el.id == UserIdToLoc(searchValue) : true))"
              :key="'unsent-' + ukey"
              v-on:applyChanges="dbSet"
              mode="unsent"
            />
          </div>
          <div v-if="flpToShow == 'sent'">
            <customerRow
              v-model="sentListShow[skey]"
              v-for="(sent, skey) in sentListShow"
              :key="'sent-' + skey"
              mode="sent"
              :colpId="'sent-' + skey"
            />
          </div>
        </div>
      </div>

      <div
        class="row"
        v-if="!loadingStatus && (flpToShow != 'sent' && unsentList.filter(el => el.flp_touch == flpToShow && (searchValue != '' ? el.id == UserIdToLoc(searchValue) : true)).length == 0)"
        style="margin-top: 33px; font-size: 16px;"
      >
        <div
          v-if="!loadingStatus && (flpToShow != 'sent' && unsentList.filter(el => searchValue != '' ? el.id == UserIdToLoc(searchValue) : true).length != 0)"
          class="col-12"
        >Customer {{searchValue != '' ? ' with Cust-No ' + searchValue : ''}} is scheduled for {{flpToShow == 'flp_1' ? 'second' : 'first'}} follow-up message</div>
        <div
          class="col-12"
          v-else
        >No customers{{searchValue != '' ? ' with Cust-No ' + searchValue : ''}} were scheduled for follow-up messaging yet</div>
      </div>

      <div
        class="row"
        v-if="!loadingStatus && (flpToShow == 'sent' && searchValue_sent == '' && sentListShow.length == 0)"
        style="margin-top: 33px; font-size: 16px;"
      >
        <div
          class="col-12"
        >No messages {{sentReplyFilter == 'reply' ? 'with customer replies' : sentReplyFilter == 'noreply' ? 'with no customer replies' : 'were sent'}} for selected period (from {{FormatDateToMMDDYYY(dateFrames[datePeriodSelected].startDate)}} till {{FormatDateToMMDDYYY(dateFrames[datePeriodSelected].endDate)}})</div>
      </div>

      <!-- <div v-if="loadingSentStatus">
        <b-spinner variant="primary" label="Spinning" style="margin-top: 100px;"></b-spinner>
      </div>-->

      <div v-if="loadingStatus">
        <b-spinner variant="primary" label="Spinning" style="margin-top: 100px;"></b-spinner>
      </div>

      <!-- Ending note -->

      <b-modal
        id="modal-flp-settings"
        title="Settings"
        ref="modal-flp-settings"
        @ok="SetFlpSettings()"
        ok-title="Apply"
        @show="LoadAvalTime()"
        size="lg"
      >
        <div v-if="loadingFlpSettings">
          <b-spinner variant="primary" label="Spinning" style="margin-top: 100px;"></b-spinner>
        </div>
        <div v-if="!loadingFlpSettings && Object.keys(this.flp_settings).length > 0">
          <b-tabs content-class="mt-3">
            <b-tab
              v-for="setTab in settingMainTabs"
              :key="setTab.value"
              :title="setTab.name"
              @click="fst = setTab.value"
              :active="fst == setTab.value"
            ></b-tab>
          </b-tabs>

          <flpSettingTab
            :flp_set="flp_settings[fst]"
            v-on:settingsChanged="$set(flp_settings, fst, $event)"
            :key="fst"
          />
        </div>
      </b-modal>

      <b-modal
        size="lg"
        id="modal-custom-sent-date"
        ref="modal-custom-sent-date"
        centered
        title="Select Timeframe"
        ok-title="Ok"
        :ok-disabled="disableCustDateBtn"
        @ok="AddTimeAndLoadSentFollowUps()"
      >
        <DatePickerForm
          v-model="dateFrames['custom']"
          v-on:datePickBtnDisable="disableCustDateBtn = $event"
        />
      </b-modal>
    </div>
  </div>
</template>


<script >
import firebase from "firebase/app";
import flpSettingTab from "./followUpComponents/Settings/flpSettingTab.vue";
import customerRow from "./followUpComponents/CustomerRow.vue";
import DatePickerForm from "./additionalComponents/datePickerForm.vue";

export default {
  name: "FollowUpPanel",
  components: {
    flpSettingTab,
    customerRow,
    DatePickerForm
  },
  props: {
    currAdmin: Object,
    unsentList: Array
  },
  data() {
    return {
      loadingStatus: false,

      datePeriodSelected: "",
      datePeriodOptions: [
        {
          value: "today",
          text: "Today"
        },
        {
          value: "yesterday",
          text: "Yesterday"
        },
        {
          value: "days3",
          text: "Last 3 days"
        },
        {
          value: "days7",
          text: "Last 7 days"
        },
        {
          value: "custom",
          text: "Enter Time Period"
        }
      ],
      dateFrames: {},
      flpStatusOptions: [
        { value: "contacted", text: "Contacted" },
        { value: "scheduled", text: "Scheduled" },
        { value: "cancelled", text: "Cancelled" },
        { value: "paused", text: "Paused" },
        { value: "review", text: "Review" },
        { value: "sent", text: "Sent", disabled: true }
      ],
      addStatusClass: {},
      addPhoneClass: {},
      addphoneProcessingUser: {},
      addedPhone: "",

      settingMainTabs: [
        {
          name: "Appointment Followup",
          value: "appointment"
        },
        {
          name: "Parts Followup",
          value: "parts"
        }
      ],
      fst: "appointment",
      loadingFlpSettings: false,
      flp_settings: {},

      sentList: [],
      sentListShow: [],

      loadingSentStatus: false,
      sentReplyFilter: "all",

      disableCustDateBtn: true,

      searchValue: "",
      searchValue_sent: "",
      flpToShow: "flp_1",
      flpSentTouchPool: [
        { value: "all", text: "All" },
        { value: "flp_1", text: "First touch" },
        { value: "flp_2", text: "Second touch" }
      ],
      flpSentTouch: "all",
      locs: {
        londonderrydodge: {
          name: "Londonderry Dodge",
          sname: "LDC"
        },
        northsidemitsubishi: { name: "NorthSide Mitsubishi", sname: "NSM" },
        lanissan: { name: "LaNissan", sname: "LAN" },
        lamazda: { name: "LaMazda", sname: "LAM" },
        northsidenissan: { name: "NorthSide Nissan", sname: "NSN" },
        rivercityhyundai: { name: "Rivercity Hyundai", sname: "RCH" },
        sherwoodkia: { name: "Sherwood Kia", sname: "SPK" },
        sherwoodnissan: { name: "Sherwood Nissan", sname: "SPN" }
      }
    };
  },

  created() {
    this.datePeriodOptionsSetup();
  },
  watch: {},

  methods: {
    AddTimeAndLoadSentFollowUps() {
      if (this.datePeriodSelected != "customSelected") {
        let inx = this.datePeriodOptions.findIndex(
          el => el.value == "customSelected"
        );
        if (inx >= 0) {
          this.datePeriodOptions.splice(inx, 1);
        }
        if (this.dateFrames.customSelected != undefined) {
          delete this.dateFrames.customSelected;
        }
      }

      this.dateFrames["customSelected"] = {
        startDate: `${this.dateFrames["custom"].startDate}T00:00:01-07:00`,
        endDate: `${this.dateFrames["custom"].endDate}T23:59:59-07:00`
      };

      this.datePeriodSelected = "customSelected";
      this.datePeriodOptions.splice(this.datePeriodOptions.length - 1, 0, {
        value: "customSelected",
        text: `${this.FormatDateToMMDDYYY(
          this.dateFrames["customSelected"].startDate
        )}-${this.FormatDateToMMDDYYY(
          this.dateFrames["customSelected"].endDate
        )}`
      });

      this.loadSentFollowUps();
    },

    sentDatePeriodIsSelected() {
      this.dateFrames["custom"] = {
        startDate: "",
        endDate: ""
      };

      if (this.datePeriodSelected == "custom") {
        this.$refs["modal-custom-sent-date"].show();
      } else {
        this.loadSentFollowUps();
      }
    },

    loadSentFollowUps() {
      this.loadingStatus = true;
      this.sentList = [];
      this.searchValue_sent = "";

      this.GetSecondANDAllTouchSent();
    },

    SearchSentById() {
      this.loadingStatus = true;
      this.flpSentTouch = "all";
      this.sentReplyFilter = "all";
      this.sentList = [];
      let that = this;

      firebase
        .firestore()
        .collection(`followup/${this.currAdmin.location}/sent`)
        .where(
          "id",
          "==",
          `${
            this.currAdmin.location != "londonderrydodge"
              ? this.locs[this.currAdmin.location].sname + "-"
              : ""
          }${this.searchValue_sent.trim()}`
        )
        .get()
        .then(r => {
          r.forEach(rs => {
            let tm = rs.data();

            tm["service_sent_time"] =
              tm.sent_time_num_2 == -1
                ? tm.flps[0].sent_time
                : tm.flps[1].sent_time;
            tm["service_touch"] = tm.sent_time_num_2 == -1 ? "flp_1" : "flp_2";
            that.sentList.push(tm);
          });

          that.loadingStatus = false;
          that.SortSentList();
          that.FilterSentList();
        });
    },

    GetFristTouchSent() {
      let that = this;
      firebase
        .firestore()
        .collection(`followup/${this.currAdmin.location}/sent`)
        .where(
          "sent_time_num_1",
          ">=",
          Date.parse(
            new Date(this.dateFrames[this.datePeriodSelected].startDate)
          )
        )
        .where(
          "sent_time_num_1",
          "<=",
          Date.parse(new Date(this.dateFrames[this.datePeriodSelected].endDate))
        )
        .where("sent_time_num_2", "==", -1)
        .get()
        .then(r => {
          r.forEach(rs => {
            let tm = rs.data();
            tm["service_sent_time"] = tm.flps[0].sent_time;
            tm["service_touch"] = "flp_1";
            that.sentList.push(tm);
          });

          that.loadingStatus = false;
          that.SortSentList();
          that.FilterSentList();
        });
    },

    GetSecondANDAllTouchSent() {
      let that = this;
      firebase
        .firestore()
        .collection(`followup/${this.currAdmin.location}/sent`)
        .where(
          "sent_time_num_2",
          ">=",
          Date.parse(
            new Date(this.dateFrames[this.datePeriodSelected].startDate)
          )
        )
        .where(
          "sent_time_num_2",
          "<=",
          Date.parse(new Date(this.dateFrames[this.datePeriodSelected].endDate))
        )
        .get()
        .then(r => {
          r.forEach(rs => {
            let tm = rs.data();
            tm["service_sent_time"] = tm.flps[1].sent_time;
            tm["service_touch"] = "flp_2";
            that.sentList.push(tm);
          });

          // if (this.flpSentTouch == "flp_2") {
          //   that.loadingStatus = false;
          //   that.SortSentList();
          //   that.FilterSentList();
          // } else {
          that.GetFristTouchSent();
          // }
        });
    },

    datePeriodOptionsSetup() {
      let today = new Date();
      let yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      let days3 = new Date();
      days3.setDate(today.getDate() - 3);
      let days7 = new Date();
      days7.setDate(today.getDate() - 7);
      this.dateFrames["today"] = this.SetTimeFormat(today, today);
      this.dateFrames["yesterday"] = this.SetTimeFormat(yesterday, yesterday);
      this.dateFrames["days3"] = this.SetTimeFormat(days3, yesterday);
      this.dateFrames["days7"] = this.SetTimeFormat(days7, yesterday);
      this.dateFrames["custom"] = {
        startDate: "",
        endDate: ""
      };

      this.datePeriodSelected = "today";
    },

    FilterSentList() {
      this.sentListShow = [];
      let tmp =
        this.sentReplyFilter == "reply"
          ? this.sentList.filter(el => el.reply_received === true)
          : this.sentReplyFilter == "noreply"
          ? this.sentList.filter(el => el.reply_received !== true)
          : this.sentList;

      this.sentListShow =
        this.flpSentTouch != "all"
          ? tmp.filter(el => el.service_touch == this.flpSentTouch)
          : tmp;
    },

    SetTimeFormat(t1, t2) {
      return {
        startDate: `${t1.getFullYear()}-${
          t1.getMonth() + 1 < 10 ? "0" : ""
        }${t1.getMonth() + 1}-${
          t1.getDate() < 10 ? "0" : ""
        }${t1.getDate()}T00:00:01-07:00`,
        endDate: `${t2.getFullYear()}-${
          t2.getMonth() + 1 < 10 ? "0" : ""
        }${t2.getMonth() + 1}-${
          t2.getDate() < 10 ? "0" : ""
        }${t2.getDate()}T23:59:59-07:00`
      };
    },

    LoadAvalTime() {
      this.fst = "appointment";

      this.loadingFlpSettings = true;

      let that = this;
      firebase
        .firestore()
        .collection(`followup/${this.currAdmin.location}/settings`)
        .get()
        .then(r => {
          let dt = new Object();
          r.forEach(rs => {
            dt[rs.id] = rs.data();
          });
          that.LoadFlpObj(dt);
        });
    },

    LoadFlpObj(dt) {
      this.flp_settings = Object.assign({}, this.flp_settings, dt);
      this.loadingFlpSettings = false;
    },

    SetFlpSettings() {
      for (let ky in this.flp_settings) {
        firebase
          .firestore()
          .doc(`followup/${this.currAdmin.location}/settings/${ky}`)
          .set(this.flp_settings[ky], { merge: true });
      }
    },

    dbSet: function(data) {
      data.ref = data.ref.replace("{{loc}}", this.currAdmin.location);
      firebase
        .database()
        .ref(data.ref)
        .update(data.value);
    },

    SortSentList() {
      //Date.parse(a.service_sent_time) > Date.parse(b.service_sent_time)
      this.sentList.sort((a, b) =>
        a.service_sent_time > b.service_sent_time ? 1 : -1
      );
    },

    FormatDateToMMDDYYY(t) {
      let tt = new Date(t).toString().split("GMT")[0];
      let tta = tt.split(" ");
      return `${tta[1]} ${tta[2]} ${tta[3]}`;
    },

    UserIdToLoc(id) {
      return `${
        this.currAdmin.location != "londonderrydodge"
          ? this.locs[this.currAdmin.location].sname + "-"
          : ""
      }${id}`;
    }
  }
};
</script>

<style scoped>
.headerStyleFlUp {
  height: 44px;
  /* background-color: #b9b3b35d; */
  border-bottom: 1px solid black;
}

.headerStyleInnerFlUp {
  height: 44px;
  /* background-color: #b9b3b35d; */
  margin-top: 20px;
  cursor: pointer;
  /* border-bottom: 1px solid black; */
}

.mb--0 {
  margin-bottom: 0;
}

.headerStyleFlpInTxtMain {
  line-height: 44px;
  text-align: left;
  font-weight: bold;
  font-size: 22px;
}

.headerStyleFlpInTxtMain select {
  border: 0px;
  line-height: 44px;
  text-align: left;
  font-weight: bold;
  font-size: 22px;
  padding-top: 0;
}

.flp-date-changer select {
  /* background: #6c757d; */
  color: #266db3;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #266db3;
  width: 100%;
  font-weight: bold;
  cursor: pointer;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 0px 15px;
  height: 1.8rem;
  margin-top: 3px;
}
.mb-5px {
  margin-bottom: 5px;
}
.padd-0 {
  padding: 0;
}
.no-border {
  border: 0;
  border-radius: 0;
  /* border-bottom: 1px solid; */
}
.aval-from-style {
  padding-left: 0px;
  padding-right: 3px;
  border-right: 1px solid lightgrey;
}

.aval-till-style {
  padding-left: 7px;
  padding-right: 0;
}

.m-color {
  color: #266db3;
}

.collapseHover:hover {
  background-color: aliceblue;
}
.autoOverflow-flp {
  height: 87vh;
  width: 100%;
  overflow-y: auto;
  resize: vertical;
}
.align-right {
  text-align: right;
}
.flp-msgbox-style {
  text-align: left;
  margin-bottom: 1rem;
}
.searchWordStyle {
  padding-top: 7px;
  text-align: right;
  font-size: 18px;
  color: dimgrey;
}
/deep/ .tgf-disable-input {
  color: #6c757d;
  background-color: #e9ecef;
}

/deep/ .tagify {
  min-height: 86px;
}
</style>